
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Site WordPress ou sur-mesure : quelle solution choisir ?",
    description:
      "WordPress ou site sur-mesure ? Découvrez les avantages et inconvénients de chaque solution pour faire le bon choix. ALEO vous accompagne dans votre projet digital.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
